// Importación de librerías y componentes necesarios
import axios from "axios";
import React, { useState, useEffect } from 'react';
import TodoDataService from '../../../hooks/services'


import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


import CarruselProductos from "../../../components/Carrusel_Productos";

// Componente funcional ContentModalAgregarCarrito
const ContentModalAgregarCarrito = ({ProductoDefault, Title, AgregarCarritoExtra, CarritoExtra, OnClickClose, ProductoSelecionado, OnClickAgregarCarrito, Token, ListCarrito, ListCarritoExtra = [], FormatearComoMonedaMXN, Styles }) => {
    // Definición de estados utilizando useState
    const [DescripcionProducto, setDescripcionProducto] = useState([]);
    const [resultado, setresulatdo] = useState([]);
    const [cantidad, setcantidad] = useState(ListCarritoExtra.length > 0 ? ListCarritoExtra.find((item) => (item.producto === ProductoSelecionado.producto)) ? ListCarritoExtra.find((item) => (item.producto === ProductoSelecionado.producto)).cantidad : 1 : 1);

    // Efecto secundario para realizar una consulta cuando el componente se monta
    useEffect(() => {
        // Función asíncrona para consultar la descripción del producto
        const ConsultarDescripcion = async () => {
            try {
                // Configuración de la autorización en las cabeceras de la solicitud HTTP
                axios.defaults.headers.common["Authorization"] = Token;
                // Solicitud HTTP para obtener la descripción adicional del producto
                const respuesta = await axios.request(TodoDataService.GetHostRestApi()+ "/Productos/DescripcionesAdicionales/" + ProductoSelecionado.producto.trim());
                // Actualización del estado con la respuesta obtenida
                setDescripcionProducto(respuesta.data);
            } catch (error) {
                // Manejo de errores
                setDescripcionProducto([])
            }
        }
        // Llamada a la función para consultar la descripción al montar el componente
        ConsultarDescripcion();
        // Actualización del estado 'resultado' con la búsqueda del producto en el carrito
        setresulatdo(ListCarrito.find((item) => item.producto === ProductoSelecionado.producto));
    }, []);

     const [zoomRatio, setZoomRatio] = useState("16/9");

  useEffect(() => {
    const handleZoomChange = () => {
      const zoom = Math.round(window.devicePixelRatio * 100);

      let ratio = "16/9"; // valor por defecto (100%)
      if (zoom >= 120 && zoom < 135) ratio = "21/9";
      else if (zoom >= 135 && zoom < 150) ratio = "23/9";
      else if (zoom >= 150 && zoom < 160) ratio = "24/9";
      else if (zoom >= 160 && zoom < 170) ratio = "25/9";
      else if (zoom >= 170 && zoom < 185) ratio = "26/9";
      else if (zoom >= 185) ratio = "28/9";

      setZoomRatio(ratio);
    };

    handleZoomChange(); // Ejecutar al montar
    window.addEventListener("resize", handleZoomChange);

    return () => window.removeEventListener("resize", handleZoomChange);
  }, []);

    // Renderizado del componente
    return (
        <div style={{ margin: '0% 0% ', padding: '0px' }} className="row">
            <Typography textAlign='center' marginBottom='1rem' fontSize='25px'  variant="h5" color='#D14081 !important'>
                {Title}
            </Typography>
            {/* Sección izquierda con el slider de imágenes */}
            <div className="col-lg-9">
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {/* Slider principal */}

                    <CarruselProductos ListImagen={ProductoSelecionado.img} AspectRation={zoomRatio} />


                </div>
            </div>
            {/* Sección derecha con la descripción y opciones de compra */}
            <div className="col-lg-3 mt-0 text-center" style={{ display: 'flex', flexWrap: 'wrap', alignContent: 'space-between' }}>
                <Box sx={{ width: '100%' }}>
                    <div className="col-sm-12 mb-3 text-center">
                        <div><Typography textAlign='center' variant="h6" fontSize='18px' marginTop={{xs:'20px', sm:'0px'}} color="#D14081 !important">Descripción</Typography></div>
                    </div>

                    {/* Renderizado de la descripción del producto */}
                    {
                        DescripcionProducto.length > 0
                            ?
                            DescripcionProducto.map(element => (
                                <ul className="mb-2" id="lista_descripcion" style={{ listStyleType: 'none', paddingLeft: '0px',fontSize:'18px' }} key={element.id}>
                                    <li>- {element.descripcion}</li>
                                </ul>
                            ))
                            :
                            <Typography fontSize='15px' textAlign='center'  >- Sin descripción por el momento</Typography>
                    }

                    {/* Renderizado del precio y opciones de compra */}
                </Box>

                <Box sx={{ width: '100%' }} >
                    {/* Renderizado de los botones de agregar al carrito */}
                    {
                        // Opciones específicas según el estado de CarritoExtra y resultado
                        CarritoExtra === true
                            ?
                            <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}> {/* Si es un producto extra */}
                                <div className="col-sm-3" >
                                </div>
                                <Box mt={2} className="col-sm-12">
                                                        <Typography variant="h5" sx={{ fontSize: '24px',color:'#D14081!important'}}> {CarritoExtra === true ? 'Precio unitario: ' + FormatearComoMonedaMXN(ProductoSelecionado.precio_venta) : ''}</Typography>

                                </Box>
                                <Box mt={2} className="col-sm-12" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <IconButton disabled={cantidad === 0 ? true : false} type="button" onClick={() => (setcantidad(cantidad - 1))} sx={{ padding: '2px' }}><RemoveIcon sx={{ color: '#b0427e' }} /></IconButton >
                                    <input style={{ paddingLeft: '0px', paddingRight: '0px', width: '40px', textAlign: 'center' }} type="text" id="inCantidad" className="form-control gris" value={cantidad} />
                                    <IconButton type="button" onClick={() => (setcantidad(cantidad + 1))} sx={{ padding: '2px' }} ><AddIcon sx={{ color: '#b0427e' }} /></IconButton >

                                </Box>
                                

                                <Box mt={2} className="col-sm-12" >
                                    <Styles>
                                        <button disabled={cantidad > 0 ? false : true} type="button" style={{ marginTop: '5px', width: '100%' }} id="btnAgregaCarrito" onClick={() => (AgregarCarritoExtra(ProductoSelecionado, cantidad))} className="btn btnAmarilloChicos g">
                                            Añadir producto: {FormatearComoMonedaMXN(ProductoSelecionado.precio_venta * cantidad)}
                                        </button>
                                    </Styles>
                                </Box>
                            </div>
                            : // Si es un producto no extra
                            ProductoSelecionado.valor_default === 1 
                                ?
                                <>
                                    <Box className="col-sm-12">
                                        <Typography fontSize='18px' variant="h5"  color='#D14081'>Incluido en el set</Typography>
                                    </Box>
                                    <Box mt={2} className="col-sm-12" >
                                        <Styles>
                                            <button type="button" style={{ marginTop: '0px', width: '100%' }} id="btnConfirmar" onClick={() => (OnClickAgregarCarrito(ProductoSelecionado))} className="btn btnAmarilloChicos g">Siguiente</button>
                                        </Styles>
                                    </Box>
                                </>
                                : // Si es un producto adicional
                                ProductoSelecionado.valor_default === 0 && resultado === undefined
                                    ?
                                    <div className="row" sty >
                                        <Box className="col-sm-12" sx={{ display:'flex',justifyContent:'center', alignItems:'center',  paddingRight: '6px !important' }}>
                                            <Typography variant="h5" fontSize='25px'  color='#D14081'>
                                                Adicional {FormatearComoMonedaMXN(ProductoSelecionado.precio_venta - ProductoDefault.precio_venta)}
                                            </Typography>
                                        </Box>
                                        <Box mt={2} className="col-sm-12" >
                                            <Styles style={{  margin: '0px !important' }}>
                                                <button type="button" style={{ margin: '0px', width: '100%'}} id="btnConfirmar" onClick={() => (OnClickAgregarCarrito(ProductoSelecionado))} className="btn btn-secondary  btnAmarilloChicos g">
                                                    {/* <ShoppingCartOutlinedIcon sx={{ color: 'white' }} /> */}
                                                    Añadir
                                                </button>
                                            </Styles>
                                        </Box>
                                    </div>
                                    : // Si el producto ya está en el carrito
                                    resultado !== undefined
                                        ?
                                        <>
                                            <div className="col-sm-12">
                                                <Styles>
                                                    <button onClick={() => (OnClickClose(ProductoSelecionado))} type="button" style={{ marginTop: '10px', width: '250px' }} id="btnConfirmar" className="btn btnAmarilloChicos g">
                                                        Producto agregado ✔
                                                    </button>
                                                </Styles>
                                            </div>
                                        </>
                                        : // Renderizado vacío si ninguna condición es verdadera
                                        <></>
                    }
                </Box>
            </div>
        </div>
    );
}

// Exportación del componente ContentModalAgregarCarrito
export default ContentModalAgregarCarrito;
